import Skeleton from "@mui/material/Skeleton";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ISubscriptionSearchParams } from "../../../store/subscriptions/types";
import { fetchSubscriptionRequest, deleteSubscriptionReq, deleteSubscriptionSuccess} from "../../../store/subscriptions/actions";
import { fetchSubscriptionPendingSelector, fetchSubscriptionSelector, deleteSubscriptionSelector } from "../../../store/subscriptions/selectors";
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { getProfileDataSelector } from "../../../store/auth/selectors";

// icons
import {IconButton, Tooltip} from '@mui/material/';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';


const SubscriptionExplorer = () => {
  const [dataRows, setDataRows] = useState<any>([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const subscriptionList = useSelector(fetchSubscriptionSelector);
  const subscriptionPendingList = useSelector(fetchSubscriptionPendingSelector);
  const deleteSubscriptionSuccess = useSelector(deleteSubscriptionSelector);
  const userProfile = useSelector(getProfileDataSelector);
  const [ownerValue, setOwnerValue] = useState("");

  useEffect(() => {
    if (userProfile && userProfile?.mail) {
      setOwnerValue(userProfile?.mail);

    }
  }, [userProfile]);

  const params: ISubscriptionSearchParams = {
    subscriber: ownerValue,
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (ownerValue) {
      dispatch(fetchSubscriptionRequest(params));
    }
  }, [ownerValue]);

  useEffect(() => {
    const newRows = subscriptionList && subscriptionList !== undefined && subscriptionList.length > 0 ?
      subscriptionList?.map((item: any, index: number) => { return { ...item, id: index } })
      : []
    setDataRows(newRows);
  }, [subscriptionList]);

    // if subscription deleted successfully
    useEffect(() => {

      if (deleteSubscriptionSuccess?.isSuccess) {
        dispatch(fetchSubscriptionRequest(params));
      }
  }, [deleteSubscriptionSuccess]);


  const renderRowIconButtons = (params: any) => {
    return (
        <strong>
            <IconButton
                size="small"
                onClick={() => {
                  if (params.row.type == 'EXTRACTOR') {
                    navigate(`/ViewDataExtractor/${params.row.batchCode.toUpperCase()}`)
                  }
                  else {
                    navigate(`/ViewDataTarget/${params.row.layerId}`);
                  }
                }}
                >
                <Tooltip title="View">
                    <VisibilityIcon color="action" />
                </Tooltip>
            </IconButton>
            <IconButton
                size="small"
                onClick={() => {
                  dispatch(deleteSubscriptionReq(params.row.subscriptionId, params.row.type));
                }}
                >
                <Tooltip title="Unsubscribe">
                    <DeleteForeverIcon color="action" />
                </Tooltip>
            </IconButton>
        </strong>
    )
  }

  return (
    <>
      {/* adding skeleton screen on loading */}
      {subscriptionPendingList ? (
        <Grid container width="100%">
          <Grid item xs={12}>
            <Skeleton animation="wave" height={60} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton animation="wave" height={60} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton animation="wave" height={60} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton animation="wave" height={60} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton animation="wave" height={60} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton animation="wave" height={60} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton animation="wave" height={60} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton animation="wave" height={60} />
          </Grid>
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Stack spacing={2} alignItems='flex-start' style={{ width: '100%' }}>
            <Box sx={{ width: '100%', height: 600, bgcolor: 'background.paper' }}>
              <DataGrid
                pagination
                rows={dataRows}
                sortingOrder={['asc', 'desc']}
                sx={{
                  wordBreak: "break-word",

                }}
                initialState={{
                  sorting: {
                    sortModel: [{ field: 'description', sort: 'desc' }],
                  },
                }}
                rowsPerPageOptions={[30, 50, 100]}
                columns={[
                  {
                    field: 'name',
                    headerName: 'Name',
                    flex: 0.25
                  },
                  {
                    field: 'description',
                    headerName: 'Description',
                    flex: 0.25
                    //width: 400,
                  },
                  {
                    field: 'owner',
                    headerName: 'Owner',
                    flex: 0.2
                    //width: 200,
                  },
                  {
                    field: 'type',
                    headerName: 'Type',
                    flex: 0.1
                    //width: 150,
                  },
                  {
                    field: 'subscriptionId',
                    headerName: 'Subscription ID',
                    flex: 0.2
                    //width: 250,
                  },
                  {
                    field: 'buttonCol',
                    headerName: '',
                    width: 90,
                    renderCell: renderRowIconButtons,
                    //disableClickEventBubbling: true,
                  }
                ]}
              />
            </Box>
          </Stack>
        </Grid>
      )}
    </>
  );
}
export default SubscriptionExplorer;
